import React from 'react';
import {OnboardingCtxProvider} from './Onboarding.context';
import {Onboarding} from './Onborading';

const onboardingRef: React.RefObject<typeof Onboarding> = React.createRef();

export async function renderOnboardingDialog(root) {
    root.render(
        <OnboardingCtxProvider>
            <Onboarding ref={onboardingRef} />
        </OnboardingCtxProvider>
    );

    return onboardingRef;
}
